import { DescriptionPage_ProductVariant as DescriptionPageProductVariant } from '__generated__/graphql-types';

import _t from 'i18n!nls/xdp';

const getVariantTitle = (productVariant?: DescriptionPageProductVariant) => {
  if (productVariant === DescriptionPageProductVariant.StandardSpecialization) {
    return _t('Specialization');
  } else if (
    productVariant === DescriptionPageProductVariant.ProfessionalCertificate ||
    productVariant === DescriptionPageProductVariant.ExternalCertificate ||
    productVariant === DescriptionPageProductVariant.GoogleCertificate
  ) {
    return _t('Professional Certificate');
  }
  return _t('course');
};

export default getVariantTitle;
